import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '@/types';

interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  isSessionExpired: boolean;
  user: User | null;
  accessToken: string | null;

  setAuth: (user: User, accessToken: string) => void;
  clearAuth: () => void;
  setLoading: (loading: boolean) => void;
  setSessionExpired: (expired: boolean) => void;
  setAccessToken: (token: string) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      isLoading: true,
      isSessionExpired: false,
      user: null,
      accessToken: null,

      setAuth: (user, accessToken) =>
        set({
          isAuthenticated: true,
          user,
          accessToken,
          isLoading: false,
        }),

      clearAuth: () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        set({
          isAuthenticated: false,
          user: null,
          accessToken: null,
          isLoading: false,
          isSessionExpired: false,
        });
      },

      setLoading: (loading) => set({ isLoading: loading }),

      setSessionExpired: (expired) => set({ isSessionExpired: expired }),

      setAccessToken: (token) => set({ accessToken: token }),
    }),
    {
      name: 'super-admin-auth-storage',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        user: state.user,
        accessToken: state.accessToken,
      }),
    }
  )
);
